var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 7,
    r: 5,
    fill: "#FFCC06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2733 20.5913C16.6866 21.0652 17.1605 21.3019 17.7517 21.4197V13.6689H14.2021C14.3205 15.6212 14.7349 19.0535 16.2733 20.5913Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9717 -4.02671e-08C11.1836 -4.02671e-08 0 11.183 0 24.97C0 38.7575 11.1836 50 24.9717 50C38.7575 50 50.0011 38.7575 50.0011 24.97C50.0011 11.183 38.7575 -4.02671e-08 24.9717 -4.02671e-08ZM31.0057 40.947C31.0057 41.0654 30.8879 41.1837 30.7107 41.1837H18.9365C18.7576 41.1837 18.6399 41.0654 18.6399 40.947V37.9881C18.6399 37.8114 18.7576 37.6925 18.9365 37.6925H19.8232C20.0004 37.6925 20.1788 37.5747 20.1788 37.3969V36.9236C20.1788 36.7458 20.2971 36.628 20.4743 36.628H22.8411H26.8656H29.1734C29.3501 36.628 29.469 36.7458 29.469 36.9236V37.3969C29.469 37.5747 29.6462 37.6925 29.8234 37.6925H30.7112C30.8885 37.6925 31.0062 37.8108 31.0062 37.9881V40.947H31.0057ZM34.7347 20.9466C33.9646 21.776 33.0774 22.1894 32.0118 22.3072C31.5979 25.0889 29.4679 27.3967 26.7461 28.0462V29.1706C26.9823 29.1706 27.2195 29.1118 27.4556 29.0523C27.6323 29.1706 27.7512 29.4068 27.7512 29.5857C27.7512 30.0584 27.3373 30.4129 26.8645 30.4129H26.5089V35.0291H26.8645C27.3373 35.0291 27.7512 35.3841 27.7512 35.798C27.7512 35.9164 27.7512 35.9752 27.6923 36.0947H21.9533C21.9533 35.9752 21.9533 35.9164 21.9533 35.798C21.9533 35.3841 22.3072 35.0291 22.8405 35.0291H23.1361V30.4129H22.8405C22.3072 30.4129 21.9533 30.0584 21.9533 29.5857C21.9533 29.4068 22.0116 29.1706 22.1894 29.0523C22.4861 29.1118 22.8405 29.1706 23.1366 29.2301H23.255V28.0462C20.4743 27.3967 18.3437 25.0889 17.9304 22.3072C16.9243 22.1888 15.9776 21.7755 15.2076 20.9466C12.5453 18.2243 12.6047 12.1892 12.6047 11.893C12.6047 11.4191 13.0186 11.0647 13.4925 11.0647H17.8704V9.22965C17.8704 8.93464 18.1076 8.75686 18.3443 8.75686H31.5985C31.8946 8.75686 32.0718 8.93464 32.0718 9.22965V11.0647H36.4503C36.9236 11.0647 37.3381 11.4191 37.3381 11.893C37.3375 12.1892 37.3969 18.2243 34.7347 20.9466Z",
    fill: "#1E334E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8054 17.3376L29.7044 15.4442H26.0948H26.0359V15.3848L24.912 12.248L23.7876 15.3848V15.4442H23.7281H20.1191L23.0181 17.3376H23.077V17.397L21.9531 20.5321L24.912 18.5804H24.9715L27.871 20.5321L26.7465 17.397V17.3376H26.8054Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8936 21.4197C32.4263 21.3013 32.8997 21.0652 33.3736 20.5913C34.8531 19.0535 35.3259 15.6212 35.3847 13.6689H31.8941V21.4197H31.8936Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.5d5f2ca6210d367c3ebe0fcadfafe751.svg";
export { ForwardRef as ReactComponent };